import { Button } from '@/components/ui/button'
import { CheckCheck, X } from 'lucide-react'

interface SuggestionPopoverProps {
  position: { x: number; y: number }
  onApprove: () => void
  onReject: () => void
  onClose: () => void
}

export function SuggestionPopover({ position, onApprove, onReject }: SuggestionPopoverProps): JSX.Element {
  return (
    <div
      className="suggestion-popover fixed z-[1000] flex -translate-x-1/2 -translate-y-1/2 items-center gap-3 rounded-md border border-border bg-[hsl(var(--muted))] p-3 shadow-inner"
      style={{
        left: position.x,
        top: position.y,
      }}
    >
      <Button variant="light" className="flex items-center gap-1 bg-green-500/10" onClick={onApprove}>
        <CheckCheck className="h-4 w-4 stroke-[2.5]" />
        Keep
      </Button>
      <Button variant="light" className="flex items-center gap-1 bg-red-500/10" onClick={onReject}>
        <X className="h-4 w-4 stroke-[2.5]" />
        Undo
      </Button>
    </div>
  )
}
